import { render, staticRenderFns } from "./u-mobile-header-body-basic.vue?vue&type=template&id=f2174648&scoped=true"
import script from "./u-mobile-header-body-basic.vue?vue&type=script&lang=js"
export * from "./u-mobile-header-body-basic.vue?vue&type=script&lang=js"
import style0 from "./u-mobile-header-body-basic.vue?vue&type=style&index=0&id=f2174648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2174648",
  null
  
)

export default component.exports